import { createClient } from '@supabase/supabase-js';

// Supabase Auth client. Gated on env: if the keys aren't set (e.g. before you
// fill .env.production), `supabase` is null and the UI degrades gracefully
// (the Login button shows a "not configured yet" note instead of crashing).
const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isAuthConfigured = Boolean(url && anonKey);

export const supabase = isAuthConfigured
  ? createClient(url, anonKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;
